<div class="left-col">
    <div class="title">{{ 'SLOGAN.TITLE' | translate }}</div>
    <div class="sub-title">{{ 'SLOGAN.SUBTITLE' | translate }}</div>
    <div class="logo">
        <img
            src="./assets/images/TSY_Slogan_Basic_3c_n.svg"
            alt="T-Systems" />
    </div>
</div>
